import { Injectable } from '@angular/core';
import { SideDrawerConfig } from '@k12/admin-components';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideDrawerService {
  private readonly configSideNav = new BehaviorSubject<SideDrawerConfig | null>(null);
  config$ = this.configSideNav.asObservable();

  openDrawerWithComponent(config: SideDrawerConfig): void {
    this.configSideNav.next(config);
  }

  closeDrawer(): void {
    this.configSideNav.next(null);
  }
}